// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.search-form[data-v-8ecfc39c] {\n  margin-bottom: 20px;\n}\n.selectLabel .el-input__inner[data-v-8ecfc39c] {\n  height: 28px !important;\n  line-height: 28px !important;\n  border: none;\n  font-weight: bold;\n  text-align: left;\n  padding: 0 !important;\n}\n[data-v-8ecfc39c] .el-form-item {\n  margin-bottom: 0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
